import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { TranslateService } from '@ngx-translate/core';
import { ContactUsModuleRouting } from './contact-us.routing';
import { ContactUsComponent } from './Contact-us.component';

@NgModule({
  imports: [
    CommonModule,
    ContactUsModuleRouting,
    SharedModule
  ],
  declarations: [ContactUsComponent]
})
export class ContactUsModule {
  currentLang: string;
  constructor(private translate: TranslateService) {
    this.currentLang = translate.currentLang;
  }
}
